import { cx } from '@7f-ui'
import { Inter } from 'next/font/google'
import localFont from 'next/font/local'

const inter = Inter({ variable: '--font-inter', subsets: ['latin'] })
const reckless = localFont({
  variable: '--font-reckless',
  src: [
    {
      path: '../../../public/fonts/reckless/Reckless-Regular.woff2',
      style: 'normal',
    },
    {
      path: '../../../public/fonts/reckless/Reckless-SemiBold.woff2',
      style: 'normal',
      weight: '600',
    },
  ],
})

export const appFontClassName = cx(inter.variable, reckless.variable)
